import { useTranslation } from 'react-i18next';
import { useLocalSearchParams, useRouter } from 'expo-router';
import { WebEditPageShell } from '../../../components/cv/WebEditPageShell';
import { EditJobPreferencesForm } from '../../../components/cv/forms/EditJobPreferencesForm';
import { useCVData } from '../../../lib/cv-mock-data';
import { useSaveJobPreferences } from '../../../hooks/useProfileApi';
import { normalizeJobPreferencesReturnTo } from '../../../lib/job-preferences-route';
import { buildCvRoute } from '../../../lib/cv-target-route';

export default function EditJobPreferencesWebScreen() {
  const { t } = useTranslation('seeker');
  const { profileRef, target } = useCVData();
  const savePrefs = useSaveJobPreferences();
  const router = useRouter();
  const params = useLocalSearchParams<{ returnTo?: string | string[] }>();
  const returnTo = normalizeJobPreferencesReturnTo(params.returnTo);

  const handleSave = async () => {
    await savePrefs.mutateAsync(profileRef.current.jobPreferences);
  };

  const handleSaved = () => {
    if (returnTo) {
      router.replace(returnTo as never);
      return;
    }
    if (router.canGoBack()) {
      router.back();
      return;
    }
    // Target-aware: a bare '/cv' would drop a delegated editor onto their OWN
    // CV instead of the shared one they were editing (issue #246).
    router.replace(buildCvRoute('/cv', target) as never);
  };

  return (
    <WebEditPageShell title={t('cv.edit.jobPreferences')}>
      <EditJobPreferencesForm onSave={handleSave} onSaved={handleSaved} />
    </WebEditPageShell>
  );
}
